import { render, staticRenderFns } from "./DossierOutbounds.vue?vue&type=template&id=5970cd98&scoped=true&"
import script from "./DossierOutbounds.vue?vue&type=script&lang=ts&"
export * from "./DossierOutbounds.vue?vue&type=script&lang=ts&"
import style0 from "./DossierOutbounds.vue?vue&type=style&index=0&id=5970cd98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5970cd98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VDataTable,VIcon})
